function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 38,
  r: 36,
  fill: "#FFE8E8"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M56 6.816A35.834 35.834 0 0038 2C18.118 2 2 18.118 2 38s16.118 36 36 36 36-16.118 36-36c0-4.138-.698-8.112-1.983-11.813",
  stroke: "#FF1515",
  strokeWidth: 3.5,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.088 28.087l20.819 20.819M48.906 28.087L28.088 48.906",
  stroke: "#FF1515",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIcoError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "/img/ico-error.svg";
export { SvgIcoError as ReactComponent };